import {
  useAssignSetting,
  useSetting,
} from "@faire/retailer-visitor-shared/settings/__internal__/useSetting";
import { IVerticalizedImageryInSignUpXP } from "@faire/web-api--source/indigofair/data/IVerticalizedImageryInSignUpXP";
import { VERTICALIZED_IMAGERY_IN_SIGN_UP_RELAUNCH_250127 } from "@faire/web-api--source/indigofair/settings/VERTICALIZED_IMAGERY_IN_SIGN_UP_RELAUNCH_250127";

export const useSettingVerticalizedImageryInSignUp = () =>
  useSetting(
    VERTICALIZED_IMAGERY_IN_SIGN_UP_RELAUNCH_250127,
    IVerticalizedImageryInSignUpXP.Bucket.CONTROL
  );

export const useAssignSettingVerticalizedImageryInSignUp = () =>
  useAssignSetting(VERTICALIZED_IMAGERY_IN_SIGN_UP_RELAUNCH_250127);
